import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { imageCoverContainer } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { h5 } from '@helpers/typography';
import MotionTrackStyles from '@stories/Components/Carousels/Carousel/MotionTrack/MotionTrack.styles';
import Image from '@stories/Components/Misc/Image/Image';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  background-color: ${brand.lightBlue};
  overflow: hidden;

  ${MotionTrackStyles.Container},
  ${MotionTrackStyles.Track} {
    width: 100%;
  }
`;
const Title = styled.h2 `
  ${h5}

  &[data-alignment="Centralised"] {
    text-align: center;
  }
`;
const CarouselWrapper = styled.div ``;
const Item = styled.li `
  flex: 0 0 auto;
  padding-right: ${fluid(8, 16)};
`;
const ImageWrapper = styled.div `
  position: relative;
  overflow: hidden;
  height: auto;
  width: ${fluid(166, 354)};  
  aspect-ratio: 166 / 224;

  @media ${from(Device.Tablet)} {
    aspect-ratio: 354 / 481;
  }

  @media ${from(Device.DesktopSmall)} {
    aspect-ratio: 354 / 483;
  }

  [data-image-orientation='landscape'] & {
    width: ${fluid(336, 724)};
    aspect-ratio: 724 / 483;
  }
`;
const Img = styled(Image) `
  ${imageCoverContainer()}
`;
const ControlsWrapper = styled.div `
  margin-top: ${fluid(20, 32)};
`;
const GalleryStyles = {
    CarouselWrapper,
    Container,
    ControlsWrapper,
    ImageWrapper,
    Img,
    Item,
    Title,
};
export default GalleryStyles;
